export enum UserLayoutEnum {
  PRIVATE = 'Private',
  PUBLIC = 'Public',
  UNKNOWN = 'Unknown'
}

export enum UserTypeEnum {
  SUPER = 'Super',
  SYSTEM = 'System',
  ADMIN = 'Administrator',
  OPERATOR = 'Operator',
  CONTRACTOR = 'Contractor',
  USER = 'User',
  UNKNOWN = 'Unknown'
}

export enum UserRoleEnum {
  DEFAULT = 'Default',
  CS = 'Customer Service',
  ST = 'Support Team',
  BT = 'Billing Team',
  MT = 'Marketing Team',
  HR = 'HR Team',
}

export enum UserPermissionEnum {
  FULL = 'full',
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  REPORT = 'report'
}